import { createFeatureSelector } from '@ngrx/store';

import * as fromLive from '@live/reducers';

export const selectLiveEdgeState = createFeatureSelector<fromLive.IState>(fromLive.liveFeatureKey);
